//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.InheritableIntBuilder.js";
let d=[[[0,"AuxFloor",1,0],[0,"CutOnlyAlongFloorAndWall",1,0],[0,"Floor",1,0],[1,"FloorIncrementBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"FloorNumberPassesBuilder",0,"CAM.InheritableIntBuilder",0],[0,"FloorStepMethodBuilder",0,"NXObject",0],[1,"FloorStockOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"Order",1,0],[0,"Wall",1,0],[1,"WallIncrementBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"WallNumberPassesBuilder",0,"CAM.InheritableIntBuilder",0],[0,"WallStepMethod",1,0],[1,"WallStockOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.DmCmMultiplePassesCiBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DmCmMultiplePassesCiBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.DmCmMultiplePassesCiBuilder.WallStepMethodType = Object.freeze({
    "Increment" : "Increment", "Passes" : "Passes"});

SPLM.CAM.DmCmMultiplePassesCiBuilder.OrderType = Object.freeze({
    "WallFirst" : "WallFirst", "FloorFirst" : "FloorFirst"});

export default SPLM;